import { render, staticRenderFns } from "./SalesOfMonth.vue?vue&type=template&id=7f148d18"
import script from "./SalesOfMonth.vue?vue&type=script&lang=js"
export * from "./SalesOfMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports